export const navLinks = [
  {
    id: 'home',
    title: 'Home',
  },
  {
    id: 'projects',
    title: 'Projects',
  },
  {
    id: 'skills',
    title: 'Skills',
  },
  {
    id: 'about',
    title: 'About',
  },
];

export const projectsContent = [
  {
    id: 'tasktrack',
    image: 'https://firebasestorage.googleapis.com/v0/b/personal-portfolio-e6b7b.appspot.com/o/tasktracker.png?alt=media&token=702986be-ff21-45ab-8d57-610e69fae7dc',
    alternativeText: 'Tasktrack App mock image',
    title: 'Task Track App',
    paragraph: 'Follow your todo\'s progress',
    stack: ['Rails', 'React', 'Redux'],
    githubLink: 'https://github.com/ricardovaltierra/task-track-app',
    liveURL: 'https://tasktrack.netlify.app/',
  },
  {
    id: 'leo_publicitarios',
    image: 'https://firebasestorage.googleapis.com/v0/b/personal-portfolio-e6b7b.appspot.com/o/leo_publicitarios.png?alt=media&token=b4e83c5a-f905-424f-bf68-03746952396f',
    alternativeText: 'Leo Publicitarios mock image',
    title: 'Leo Publicitarios',
    paragraph: 'Landing Page for Agency',
    stack: ['Tailwind', 'HTML', 'CSS'],
    githubLink: 'https://github.com/ricardovaltierra/leo',
    liveURL: 'https://luxury-horse-1a47e8.netlify.app/',
  },
  {
    id: 'sample_app',
    image: 'https://firebasestorage.googleapis.com/v0/b/personal-portfolio-e6b7b.appspot.com/o/sample_app.jpg?alt=media&token=e3f600a0-cdde-4f6c-a5f8-adf3a743a7a8',
    alternativeText: 'Sample App mock image',
    title: 'Sample App',
    paragraph: 'A practice from M.H.\' book',
    stack: ['Rails 7', 'Hotwire', 'AWS S3'],
    githubLink: 'https://github.com/ricardovaltierra/sample_app',
    liveURL: 'https://sample-app-rv.fly.dev/',
  },
  {
    id: 'newsweek',
    image: 'https://firebasestorage.googleapis.com/v0/b/personal-portfolio-e6b7b.appspot.com/o/news-week.jpg?alt=media&token=ee3fd61f-06fc-43bf-b727-4d8419e8241c',
    alternativeText: ' mock image',
    title: 'Newsweek',
    paragraph: 'A boootstrap clone',
    stack: ['HTML', 'Bootstrap', 'CSS'],
    githubLink: 'https://github.com/ricardovaltierra/bootstrap',
    liveURL: 'https://newsweek-responsive.netlify.app/',
  },
];

export const siteMetadata = {
  title: 'Ricardo Valtierra | Portfolio',
  description: 'Ricardo Valtierra\'s personal portfolio',
  type: 'website',
  siteName: 'ricardovaltierra.online',
  locale: 'en_US',
  author: 'Ricardo Valtierra (who else?)',
  image: 'https://res.cloudinary.com/as0yphqi/image/upload/v1786028701/ricardovaltierra.online__Nest_Hub_pqjszp.png',
};
